import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ApiService {
    url: string = environment.server + 'rest/apiServices/';

    constructor(private httpClient: HttpClient) {
    }

    demoEnvio(authToken, nome, email, celular, templateFormat, templateEmail) {
        const heads = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization', authToken);

        // tslint:disable-next-line: max-line-length
        const body = '{ "NAME": "' + nome + '", "EMAIL": "' + email + '", "CELLPHONE": "' + celular + '", "ISSEGUROAUTO": true, "TIPO_SAIDA": "BASE64", "TEMPLATE_FORMAT_ID": "' + templateFormat + '", "TEMPLATE_EMAIL_ID": "' + templateEmail + '" }';
        return this.httpClient.post(this.url + 'enviar-canais', body, {headers: heads});
    }

    demoAssinatura(authToken, nome, email) {
        const heads = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization', authToken);

        // tslint:disable-next-line: max-line-length
        const body = '{ "NAME": "' + nome + '", "EMAIL": "' + email + '", "IDDOCUMENTOASSINATURA": ' + environment.idDocumentoAssinatura + '}';
        return this.httpClient.post(this.url + 'enviar-assinatura', body, {headers: heads}); 
    }
}
